
// NOTE: fixes IE
import Es6Promise from 'es6-promise';
Es6Promise.polyfill();


// WEBPACK FOOTER //
// ./tbo/js/support/legacy/ie.js